export default {
  type: "reseller-products",
  name: null,
  excerpt: "",
  price: null,
  picture: null,
  gallery: [],
  relationshipNames: ["reseller"],
  reseller: {
    type: "resellers",
    id: null,
  },
};
